<template>
	<section class="dp-layout">

		<section class="dp-left">
			<DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
		</section>

		<section class="dp-right">
			<!--工具条-->
			<toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
			<div class="dp-dept-hint">
				<span class="dp-dept-hint__label">所属机构</span>
				<span class="dp-dept-hint__value">{{ currentDepartmentName || '全部' }}</span>
			</div>
			<div class="all_page_border">
								<el-table :data="users" v-loading="listLoading" ref="table" style="width: 100%"
					@selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow">

					<el-table-column type="selection"> </el-table-column>

					<el-table-column prop="ClassName" label="班级" width></el-table-column>

					<el-table-column prop="Account" label="账号" width></el-table-column>

					<el-table-column prop="Password" label="密码" width></el-table-column>

					<el-table-column label="授权终端" width="200">
						<template slot-scope="scope">
							<template
								v-if="scope.row.AuthLog && (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length : (JSON.parse(scope.row.AuthLog || '[]').length)) > 0">
								<el-tag
									v-for="(item, idx) in (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog : JSON.parse(scope.row.AuthLog || '[]'))"
									:key="item.TerminalId + idx" type="success" style="margin-right: 4px;">
									{{ item.TerminalId }}
								</el-tag>
							</template>
							<el-tag v-else type="info">无</el-tag>
						</template>
					</el-table-column>

					<el-table-column label="授权记录" width="120">
						<template slot-scope="scope">
							<el-tag
								v-if="scope.row.AuthLog && (Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length : (JSON.parse(scope.row.AuthLog || '[]').length)) > 0"
								type="success" @click.native="showAuthLog(scope.row)" style="cursor:pointer">
								{{ Array.isArray(scope.row.AuthLog) ? scope.row.AuthLog.length :
									(JSON.parse(scope.row.AuthLog || '[]').length) }} 条
							</el-tag>
							<el-tag v-else type="info" @click.native="showAuthLog(scope.row)"
								style="cursor:pointer">无</el-tag>
						</template>
					</el-table-column>

				</el-table>

				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
						:page-size="PageSize" :total="total" style="float: right"></el-pagination>
				</el-col>
			</div>
			<!--编辑界面-->
			<el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible"
				:close-on-click-modal="false">
				<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="editForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" v-if="options && options.length > 0" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="editForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="editForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="editForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="editForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--新增界面-->
			<el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
				<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
					<el-form-item label="标题" prop="Title">
						<el-input v-model="addForm.Title" auto-complete="off"></el-input>
					</el-form-item>

					<el-form-item label="所属机构" v-if="options && options.length > 0" prop="Dids">
						<el-cascader placeholder="请选择，支持搜索功能" style="width: 100%" v-model="addForm.Dids"
							:options="options" :show-all-levels="false" filterable :key="cascaderKey"
							:props="$deptCascaderProps"></el-cascader>
					</el-form-item>

					<el-form-item label="是否发布" prop="IsPublish">
						<el-switch v-model="addForm.IsPublish"></el-switch>
					</el-form-item>
					<el-form-item label="排序" prop="Sort">
						<el-input v-model="addForm.Sort" autocomplete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="内容" prop="Content">
						<quill-editor v-model="addForm.Content" ref="myQuillEditor" :options="editorOption"
							@blur="onEditorBlur($event)" @focus="onEditorFocus($event)"
							@change="onEditorChange($event)">
						</quill-editor>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="addFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
				</div>
			</el-dialog>

			<!--授权记录对话框-->
			<el-dialog :title="'【' + this.currentDepartmentName + '】授权记录'" :visible.sync="authLogDialogVisible"
				width="720px" custom-class="dept-auth-log-dialog">
				<div class="auth-log-toolbar">
					<el-select v-model="selectedTerminalId" placeholder="请选择班牌" filterable clearable
						class="auth-log-toolbar__select">
						<el-option v-for="item in terminalSelectList" :key="item.TerminalId"
							:label="`${item.TerminalId} - ${item.TerminalName}${item.AuthDeptName ? '（已绑定：' + item.AuthDeptName + '）' : ''}`"
							:value="item.TerminalId" :disabled="!!item.DeptId" />
					</el-select>
					<div class="auth-log-toolbar__actions">
						<el-button type="primary" @click="handleManualAuth">手动授权</el-button>
					</div>
				</div>
				<el-table :data="authLogList" style="width: 100%;" max-height="360">
					<el-table-column prop="TerminalId" label="终端编号" min-width="120"></el-table-column>
					<el-table-column prop="AuthTime" label="授权时间" min-width="160"></el-table-column>
					<el-table-column label="操作" width="90" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="danger" size="mini" @click="handleUnbindTerminal(scope.row)">解绑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div slot="footer" class="dialog-footer">
					<el-button @click="authLogDialogVisible = false">关闭</el-button>
				</div>
			</el-dialog>

		</section>
	</section>
</template>

<script>
import util from '../../../util/date'
import { getClassAuthAccount, getTeachingDepartmentTree, deleteClassAuthAccount, generateClassAuth, unbindTerminal, manualAuthorizeTerminal, exportClassAuthAccount } from '../../api/modules/department';
import { prepareDeptCascaderTree, normalizeDeptId, deptIdsEqual, sanitizeDeptCascaderIds } from '../../utils/deptCascaderProps'
import { editDeptNoticeRecord, addDeptNoticeRecord } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getCplateTerminalListPage } from '../../api/modules/attendance';
import { getButtonList } from '../../promissionRouter'
import Toolbar from '../../components/Toolbar'
import DepartmentPane from '../../components/DepartmentPane'
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], // 引用，代码块
	[{ header: 1 }, { header: 2 }], // 标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], // 列表
	[{ script: 'sub' }, { script: 'super' }], // 上下标
	[{ indent: '-1' }, { indent: '+1' }], // 缩进
	[{ direction: 'rtl' }], // 文本方向
	[{ size: ['small', false, 'large', 'huge'] }], // 字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
	[{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
	[{ align: [] }], // 对齐方式
	['clean'], // 清除字体样式
	['image'], // 上传图片
]
export default {
	components: { Toolbar, DepartmentPane },
	data() {
		return {
			cascaderKey: 0,
			props: { checkStrictly: true },
			BaseApiUrl: BaseApiUrl, //网络前缀
			searchList: [
				{
					label: '名称',
					key: 'name',
				},
			],
			imageUrl: '',
			imageLoadding: false,
			editorOption: {
				placeholder: '请在这里输入',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							// 重写点击组件上的图片按钮要执行的代码
							image: function (value) {
								if (value) {
									document.querySelector('.quill-upload .el-icon-upload').click()
								} else {
									this.quill.format("image", false);
								}
							}
						}
					}
				},
			},
			buttonList: [],
			currentRow: null,
			options: [],
			filters: {},
			users: [],
			total: 0,
			page: 1,
			PageSize: 10,
			listLoading: false,
			isResouceShow: 0,
			addDialogFormVisible: false,
			editFormVisible: false, //编辑界面是否显示
			editLoading: false,
			editFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],

				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//编辑界面数据
			editForm: {
				Id: 0,
				Href: '',
				imageUrl: '',
				Title: '',
				Content: '',
				IsPublish: '',
				Sort: '',
				Dids: [],
				DepartmentId: 0,
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
			},

			addFormVisible: false, //新增界面是否显示
			addLoading: false,
			addFormRules: {
				Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				//Sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
				Dids: [
					{ required: true, message: '请选择所属机构', trigger: 'change' }
				],
			},
			//新增界面数据
			addForm: {
				Title: '',
				Href: '',
				imageUrl: '',
				Content: '',
				IsTop: '',
				IsPublish: '',
				Sort: 1,
				Dids: [],
				DepartmentId: 0,
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
			},
			DepartmentId: 0,
			SchoolId: 0,
			multipleSelection: [],
			currentDepartmentName: '',
			authLogDialogVisible: false,
			authLogList: [],

			terminalSelectList: [],
			selectedTerminalId: '',
			authLogId: 0, // 授权记录ID
		}
	},
	methods: {
		async showAuthLog(row) {
			// 假设 AuthLog 字段为 JSON 字符串或对象数组
			let log = row.AuthLog;
			this.authLogId = row.Id; // 记录当前操作的授权记录ID
			if (typeof log === 'string') {
				try {
					this.authLogList = JSON.parse(log);
				} catch {
					this.authLogList = [];
				}
			} else if (Array.isArray(log)) {
				this.authLogList = log;
			} else {
				this.authLogList = [];
			}
			this.authLogDialogVisible = true;

			// 查询班牌列表
			const res = await getCplateTerminalListPage({
				departmentId: this.DepartmentId,
				page: 1,
				intPageSize: 1000 // 可根据实际情况调整,
			});

			this.terminalSelectList = res.data.response.data || [];

			this.selectedTerminalId = '';

		},
		onEditorBlur() {
			//失去焦点事件
		},
		onEditorFocus() {
			//获得焦点事件
		},
		onEditorChange() {
			//内容改变事件
		},
		dialogCheck(selection, row) {
			this.currentRow = null
			this.$refs.table.clearSelection()
			if (selection.length === 0) {
				return
			}
			if (row) {
				this.selectCurrentRow(row)
			}
		},
		selectCurrentRow(val) {
			console.log(val)
			if (val) {
				this.currentRow = val
				this.$refs.table.clearSelection()
				this.$refs.table.toggleRowSelection(val, true)
			}
		},
		treeNodeClick(data, node, component) {
			this.DepartmentId = data.value
			this.currentDepartmentName = data.label || data.name || ''
			// 向上寻找当前节点所属的学校ID
			let schoolId = 0;
			let tempNode = node;
			while (tempNode) {
				if (tempNode.data && (tempNode.data.DeptOrgType === 'school' || tempNode.data.DeptOrgType === 'affiliateschool')) {
					schoolId = tempNode.data.value;
					break;
				}
				if (tempNode !== node || tempNode.level === 1) {
					if (tempNode.level === 2 || tempNode.level === 1) {
						schoolId = tempNode.data.value;
						break;
					}
				}
				tempNode = tempNode.parent;
			}
			this.SchoolId = schoolId || data.value;
			this.handleQuery()
		},
		callFunction(item) {
			if (typeof item.search == 'object') {
				this.filters = item.search
			} else {
				this.filters = {
					key: item.search,
				}
			}
			this[item.Func].apply(this, item)
		},
		formatCreateTime: function (row, column) {
			return !row.CreateTime || row.CreateTime == ''
				? ''
				: util.formatDate.format(
					new Date(row.CreateTime),
					'yyyy-MM-dd hh:mm:ss'
				)
		},
		handleCurrentChange(val) {
			this.page = val
			this.handleQuery()
		},
		load(tree, treeNode, resolve) {
			let para = {
				page: this.page,
				f: tree.Id,
				key: this.filters.Name,
				departmentId: this.DepartmentId,
			}
			getClassAuthAccount(para).then((res) => {
				resolve(res.data.response)
			})
		},
		//获取列表
		handleQuery() {
			let para = {
				page: this.page,
				departmentId: this.DepartmentId,
				...this.filters,
			}
			this.listLoading = true

			//NProgress.start();
			getClassAuthAccount(para).then((res) => {
				this.total = res.data.response.dataCount
				this.PageSize = res.data.response.PageSize
				this.users = res.data.response.data
				this.listLoading = false
				//NProgress.done();
			})
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//显示编辑界面
		handleEdit() {
			var row = this.multipleSelection
			if (row.length == 0 || row.length > 1) {
				this.$message({
					message: '请选择一行数据进行编辑！',
					type: 'error',
				})
				return
			}
			this.editFormVisible = true
			this.editForm = Object.assign({}, row[0])
			if (this.editForm.Dids) {
				this.$set(this.editForm, 'Dids', sanitizeDeptCascaderIds(this.editForm.Dids));
			} else {
				this.$set(this.editForm, 'Dids', []);
			}
			this.imageUrl = this.editForm.imageUrl

			let schoolId = this.SchoolId
				|| this.$store.state.activeSchoolId
				|| window.localStorage.getItem('activeSchoolId');
			if (!schoolId && row[0].Dids && row[0].Dids.length > 0) {
				schoolId = row[0].Dids.find(id => normalizeDeptId(id)) || '';
			}
			if (!schoolId) {
				schoolId = this.DepartmentId || row[0].DepartmentId || 0;
			}
			if (!normalizeDeptId(schoolId)) {
				this.$message.warning("请先选择学校");
				return;
			}

			let para = { pid: 0, scopeDepartmentId: schoolId };
			getTeachingDepartmentTree(para).then((res) => {
				++this.isResouceShow;
				const root = res.data.response;
				const targetNode = this.findSchoolNode(root, schoolId);
				if (targetNode) {
					this.options = prepareDeptCascaderTree([targetNode]);
					const deptId = row[0].DepartmentId;
					const path = this.findPathByDeptId(targetNode, deptId, []);
					if (path && path.length > 0) {
						this.$set(this.editForm, 'Dids', path);
					} else {
						this.$set(this.editForm, 'Dids', [targetNode.value]);
					}
				} else {
					this.options = prepareDeptCascaderTree(root ? [root] : []);
					const deptId = row[0].DepartmentId;
					const path = this.findPathByDeptId(root, deptId, []);
					if (path && path.length > 0) {
						this.$set(this.editForm, 'Dids', path);
					}
				}
				this.cascaderKey++; // 递增 key 强制刷新级联选择器组件以修复不显示与回显 Bug
			})
		},
		//显示新增界面
		handleAdd() {
			if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
				this.$message.warning("请先在左侧选择具体的学校机构！");
				return;
			}
			this.addFormVisible = true
			this.addForm = {
				Title: '',
				Href: '',
				Content: '',
				IsTop: false,
				IsPublish: true,
				Sort: 1,
				Dids: [],
				DepartmentId: '',
				Type: 1,
				IsExternalLink: 0,
				ExternalLink: '',
			}
			this.imageUrl = ''
			const schoolId = this.SchoolId
				|| this.$store.state.activeSchoolId
				|| window.localStorage.getItem('activeSchoolId')
				|| this.DepartmentId;
			if (!normalizeDeptId(schoolId)) {
				this.$message.warning("请先选择学校");
				return;
			}
			let para = { pid: 0, scopeDepartmentId: schoolId };
			getTeachingDepartmentTree(para).then((res) => {
				++this.isResouceShow;
				const root = res.data.response;
				const targetNode = this.findSchoolNode(root, schoolId);
				if (targetNode) {
					this.options = prepareDeptCascaderTree([targetNode]);
				} else {
					this.options = prepareDeptCascaderTree(root ? [root] : []);
				}
				this.cascaderKey++; // 递增 key 强制刷新级联选择器组件以修复不显示与回显 Bug
			})
		},
		handleAvatarSuccess(res, file) {
			this.imageLoadding = false
			console.log(res)
			this.imageUrl = res.response
		},
		quillSuccess(response) {
			if (response.success) {
				// 获取文本编辑器
				const quill = this.$refs.myQuillEditor.quill
				// 获取光标位置
				const pos = quill.getSelection().index
				// 插入图片到光标位置
				quill.insertEmbed(pos, 'image', this.$resolveImageSrc(response.response))
			} else {
				this.$message({
					message: response.msg,
					type: 'error',
				})
			}
		},
		beforeAvatarUpload(file) {
			// 这里可以过滤不要的文件
			this.imageLoadding = true
			return true
		},
		//编辑
		editSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.editLoading = true
						//NProgress.start();
						this.editForm.imageUrl = this.imageUrl
						let para = Object.assign({}, this.editForm)
						para.DepartmentId = para.Dids.pop();
						editDeptNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.editLoading = false
								return
							}
							if (res.data.success) {
								this.editLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['editForm'].resetFields()
								this.editFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//新增
		addSubmit: function () {
			if (this.imageLoadding) {
				this.$message.error('请等待封面上传')
				return
			}
			let _this = this
			this.$refs.addForm.validate((valid) => {
				if (valid) {
					this.$confirm('确认提交吗？', '提示', {}).then(() => {
						this.addLoading = true
						//NProgress.start();
						this.addForm.imageUrl = this.imageUrl
						let para = Object.assign({}, this.addForm)
						para.DepartmentId = para.Dids.pop();
						var user = JSON.parse(window.localStorage.user)
						if (user && user.uID > 0) {
							para.CreateUser = user.uRealName
						} else {
							this.$message({
								message: '用户信息为空，先登录',
								type: 'error',
							})
							_this.$router.replace(
								_this.$route.query.redirect ? _this.$route.query.redirect : '/'
							)
						}
						addDeptNoticeRecord(para).then((res) => {
							if (util.isEmt.format(res)) {
								this.addLoading = false
								return
							}
							if (res.data.success) {
								this.addLoading = false
								//NProgress.done();
								this.$message({
									message: res.data.msg,
									type: 'success',
								})
								this.$refs['addForm'].resetFields()
								this.addFormVisible = false
								this.handleQuery()
							} else {
								this.$message({
									message: res.data.msg,
									type: 'error',
								})
							}
						})
					})
				}
			})
		},
		//删除
		handleDel() {
			let row = this.multipleSelection
			if (row.length == 0) {
				this.$message({
					message: '请选择要删除的数据！',
					type: 'error',
				})
				return
			}
			this.$confirm('确认删除记录吗?', '提示', {
				type: 'warning',
			})
				.then(() => {
					this.listLoading = true
					var ids = this.multipleSelection.map((item) => {
						return item.Id
					})
					var b = ids.join(',')
					let para = { ids: b }
					deleteClassAuthAccount(para).then((res) => {
						if (util.isEmt.format(res)) {
							this.listLoading = false
							return
						}
						this.listLoading = false
						//NProgress.done();
						if (res.data.success) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
						} else {
							this.$message({
								message: res.data.msg,
								type: 'error',
							})
						}

						this.handleQuery()
					})
				})
				.catch(() => { })
		},
		//生成授权账号
		generateAuthAccount() {
			if (this.DepartmentId <= 0) {
				this.$message({
					message: "请选择要生成授权账号的部门！",
					type: "error",
				});
				return;
			}
			this.$confirm("确认要生成【" + this.currentDepartmentName + "】授权账号吗?", "提示", {
				type: "warning",
			})
				.then(() => {
					let para = { Id: this.DepartmentId };
					generateClassAuth(para).then((res) => {
						if (res.data.success) {
							this.$message({
								message: res.data.msg,
								type: "success",
							});
						} else {
							this.$message({
								message: res.data.msg,
								type: "error",
							});
						}
						this.handleQuery();
					});
				})
				.catch(() => { });
		},
		// 解绑终端
		handleUnbindTerminal(row) {
			this.$confirm('确定要解绑该终端吗？', '提示', { type: 'warning' }).then(() => {
				unbindTerminal({
					TerminalId: row.TerminalId,
					ClassAuthId: this.authLogId,
				}).then(res => {
					if (res.data && res.data.success) {
						this.$message.success('解绑成功');
						this.authLogDialogVisible = false;
						// 重新加载授权记录
						this.handleQuery();
					} else {
						this.$message.error(res.data && res.data.msg ? res.data.msg : '解绑失败');
					}
				});
			});
		},
		// 手动授权
		async handleManualAuth() {
			if (!this.selectedTerminalId) {
				this.$message.warning('请选择班牌');
				return;
			}
			this.$confirm('确定要授权？', '提示', { type: 'warning' })
				.then(() => {
					this.doManualAuth();
				})
				.catch(() => { });
		},
		// 新增实际授权方法
		async doManualAuth() {
			try {
				const res = await manualAuthorizeTerminal({
					TerminalId: this.selectedTerminalId,
					ClassAuthId: this.authLogId,
				});
				if (res.data && res.data.success) {
					this.$message.success('授权成功');
					this.authLogDialogVisible = false;
					// 重新加载授权记录
					this.handleQuery();
				} else {
					this.$message.error(res.data && res.data.msg ? res.data.msg : '授权失败');
				}
			} catch (e) {
				this.$message.error('授权失败');
			}
		},
		async exportExcel() {
			try {
				let para = {
					page: this.page,
					departmentId: this.DepartmentId,
					...this.filters
				};

				var fileName = "班级授权账号报表";
				const response = await exportClassAuthAccount(para);
				if (!response.data) {
					this.$message({
						message: "导出数据为空",
						type: "error",
					});
					return;
				}
				// 处理导出数据        
				const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', fileName + '.xlsx');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
			} catch (error) {
				console.error('下载失败:', error);
			}
		},
		// 递归寻找当前学校 ID 的部门树节点。最后更新：2026-08-29
		findSchoolNode(node, schoolId) {
			if (!node) return null;
			if (deptIdsEqual(node.value, schoolId)) {
				return node;
			}
			if (node.children && node.children.length) {
				for (let i = 0; i < node.children.length; i++) {
					const found = this.findSchoolNode(node.children[i], schoolId);
					if (found) return found;
				}
			}
			return null;
		},
		// 根据 DepartmentId 在树中递归搜索完整路径
		findPathByDeptId(node, deptId, path) {
			if (!node) return null;
			const currentPath = [...path, node.value];
			if (String(node.value) === String(deptId)) {
				return currentPath;
			}
			if (node.children && node.children.length) {
				for (let i = 0; i < node.children.length; i++) {
					const found = this.findPathByDeptId(node.children[i], deptId, currentPath);
					if (found) return found;
				}
			}
			return null;
		},

	},
	mounted() {
		let routers = window.localStorage.router
			? JSON.parse(window.localStorage.router)
			: []
		this.buttonList = getButtonList(this.$route.path, routers)
		console.log(this.buttonList);
	},
}
</script>

<style scoped less>
.custom-tbl /deep/ .has-gutter .el-checkbox {
	display: none;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 106.8px;
	line-height: 106.8px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 106.8px;
	display: block;
}

.avatar-uploader-tip {
	position: absolute;
	width: 100%;
	height: 1vw;
	bottom: 20px;
	color: gray;
	z-index: 99;
}
</style>

<!-- 授权弹窗挂到 body，需全局样式覆盖 dialog 内 el-select 默认 block。最后更新：2026-08-31 -->
<style>
.dept-auth-log-dialog .auth-log-toolbar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px 12px;
	margin-bottom: 12px;
}

.dept-auth-log-dialog .auth-log-toolbar__select {
	flex: 1 1 320px;
	min-width: 220px;
	width: auto !important;
	max-width: none;
}

.dept-auth-log-dialog .auth-log-toolbar__select.el-select {
	display: block;
}

.dept-auth-log-dialog .auth-log-toolbar__select .el-input {
	width: 100%;
}

.dept-auth-log-dialog .auth-log-toolbar__actions {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	flex-shrink: 0;
}
</style>